import { BaseRestDataProvider } from './BaseRestDataProvider';
import { FixedAsset } from '../models/FixedAsset';

export class FixedAssetRestDataProvider extends BaseRestDataProvider {
    constructor() {
        super('/v1/fixed-assets');
    }

    getAll(): Promise<FixedAsset[]> {
        return this.get<FixedAsset[]>(``);
    }

    getById(id: string): Promise<FixedAsset> {
        return this.get<FixedAsset>(`/${id}`);
    }

    add(asset: FixedAsset): Promise<FixedAsset> {
        return this.post<FixedAsset>(``, asset);
    }

    update(id: string, asset: FixedAsset): Promise<void> {
        return this.put<void>(`/${id}`, asset);
    }

    delete(id: string): Promise<void> {
        return super.delete(`/${id}`);
    }

    book(id: string, remainderCostLedgerId?: string | null): Promise<void> {
        return this.postVoid(`/${id}/book`, { remainderCostLedgerId: remainderCostLedgerId ?? null });
    }

    unbook(id: string): Promise<void> {
        return this.postVoid(`/${id}/unbook`, {});
    }

    bookDepreciation(id: string, fiscalYearId: string): Promise<void> {
        return this.postVoid(`/${id}/book-depreciation`, { fiscalYearId });
    }
}

export type { FixedAsset };

